import * as Tabs from "@radix-ui/react-tabs";
import { TabTrigger } from "../TabTrigger";
import { useEffect, useState } from "react";
export interface Tab {
  title: string;
  hasCounter?: number | null;
  id: string;
}
type TabSystemProps = Tabs.TabsProps & {
  loopable?: boolean;
  tabs?: Tab[];
  defaultValue?: string;
  syncWithUrlParams?: boolean;
};
export function TabSystem({
  tabs,
  loopable = true,
  defaultValue = tabs[0]?.id,
  syncWithUrlParams = false,
  ...rest
}: TabSystemProps): JSX.Element {
  const [initialTab] = useState(() => {
    if (syncWithUrlParams) {
      const tab = new URLSearchParams(window.location.search).get("tab");
      if (tabs.find((t) => t.id === tab)) {
        return tab;
      }
    }
    return defaultValue;
  });

  useEffect(() => {
    if (syncWithUrlParams) {
      const url = new URL(window.location.href);
      url.searchParams.set("tab", initialTab);
      window.history.pushState({}, "", url.toString());
    }
  }, [initialTab, syncWithUrlParams]);

  const onTabChange = (value: string) => {
    if (syncWithUrlParams) {
      const url = new URL(window.location.href);
      url.searchParams.set("tab", value);
      window.history.pushState({}, "", url.toString());
    }
  };

  return (
    <>
      <Tabs.Root
        {...rest}
        defaultValue={initialTab}
        onValueChange={onTabChange}
      >
        <Tabs.List loop={loopable}>
          {tabs.map(({ id, title, hasCounter = null }, index) => (
            <TabTrigger value={id} hasCounter={hasCounter} key={index}>
              {title}
            </TabTrigger>
          ))}
        </Tabs.List>
        {!!tabs && rest.children}
      </Tabs.Root>
      {}
    </>
  );
}
